import Keycloak from 'keycloak-js';

// Keycloak 인스턴스 설정 (런타임 env.js > Vite env > 기본값)
const keycloakConfig = {
  url:
    (typeof window !== 'undefined' && window.__ENV__?.KEYCLOAK_URL) ||
    import.meta.env.VITE_KEYCLOAK_URL ||
    'http://localhost:8180',
  realm:
    (typeof window !== 'undefined' && window.__ENV__?.KEYCLOAK_REALM) ||
    import.meta.env.VITE_KEYCLOAK_REALM ||
    'petrohq',
  // clientId는 모든 환경에서 동일하므로 하드코딩
  clientId: 'petrohq-web',
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
